import React from "react";
import { Col, Row } from "react-bootstrap";
import { IoIosArrowDropleftCircle } from "react-icons/io";

import style from "./OrderType.module.scss";
import { useNavigate } from "react-router-dom";
import { oxygenOrder } from "../../../../data";
import { saveOxygenType } from "../../../../redux/new-order/actions/new-orders.actions";
import { useDispatch, useSelector } from "react-redux";
import Card from "../../../../components/paymentCard/Card";
import swal from "sweetalert";

const OrderType = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let userDetails;
  if (localStorage.getItem("userToken")) {
    userDetails = JSON.parse(localStorage.getItem("userToken"));
  }

  if (!userDetails) {
    navigate("/");
  }

  const processHandler = (type) => {
    if (type === "REFILL") {
      swal("Please note that refills could take between 3-5 days");
    } else if (type === "EXCHANGE") {
      swal(
        // "Your empty cylinder will be exchanged for a full LifeBank cylinder",
        "NOTE: We will deliver a filled cylinder ahead",
      );
    } else if (type === "DROP OFF") {
      // swal("This means you do not have a cylinder and require one of ours.");
    }
    // dispatch(saveOrderType(payment));
    dispatch(saveOxygenType(type));
    navigate("/place-order/cylinder-size");
  };

  const { orderType, hospitalDetails } = useSelector(
    (state) => state.newOrderReducer,
  );
  // console.log("hospitalDetails",hospitalDetails?.requestType);

  // console.log("orderType", orderType);

  const colors = () => {
    if (orderType?.cardText === "BLOOD") return "#B70303";
    if (orderType?.cardText === "OXYGEN") return "#0779F7";
    if (orderType?.cardText === "STOCKBANK") return "#066304";
    return "#DA621B";
  };

  return (
    <>
      <div className={style.greeting}>
        <p>
          <span style={{ color: "#b70303", fontWeight: "bold" }}>
            LifeBank CSA Script |{" "}
          </span>
          Do you have empty cylinders that can be delivered on scheduled days?
        </p>
      </div>
      <div style={{ width: "97%" }}>
        <Row>
          <Col md={1}>
            <IoIosArrowDropleftCircle
              size={50}
              style={{ cursor: "pointer" }}
              onClick={() => navigate(-1)}
              color={colors()}
            />
          </Col>
          <Col md={10}>
            <h3 className={style.header} style={{ color: colors() }}>
              SELECT ORDER TYPE
            </h3>

            <h5
              style={{ color: "#b70303", fontSize: "16px", fontWeight: "bold" }}
            >
              Please inform hospitals that the empty cylinder will be exchanged
              for a full LifeBank cylinder.
            </h5>
            <div className={style.cards}>
              {/* {oxygenOrder.map((type) => (
              <Card {...type} onClick={() => processHandler(type.label)} />
            ))} */}
              {oxygenOrder
                .filter((type) => {
                  if (hospitalDetails?.requestType === "Emergency") {
                    return type.label !== "REFILL";
                  }
                  return true;
                })
                .map((type) => (
                  <Card
                    key={type.id}
                    {...type}
                    onClick={() => processHandler(type.label)}
                  />
                ))}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default OrderType;
